import { useTranslations } from "use-intl";

import { Chip } from "@/components/Chip/Chip";

export const RequiredLabel = () => {
  const t = useTranslations();

  return (
    <div className="absolute end-4 -top-3">
      <Chip label={t("required")} color="warning-soft" size="xsmall" />
    </div>
  );
};
